<dx-popup
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  title="Configuration"
  [width]="520"
  [height]="'auto'"
  [showCloseButton]="true"
  [dragEnabled]="true">

  <div *dxTemplate="let data of 'content'">

    <div class="dialog-line">
      <div class="label" title="URL de l'orchestrateur de flux">URL</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          [value]="formData().url"
          (onValueChanged)="onChangeUrl($event)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Identifiant client">Client ID</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          [value]="formData().clientId"
          (onValueChanged)="onChangeClientId($event)">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Clé d'API">Clé API</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          [value]="formData().apiKey"
          (onValueChanged)="onChangeApiKey($event)"
          mode="password">
        </dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="d-flex justify-content-end">
        <yo-button
          type="submit"
          iconClass="fas fa-save"
          [theme]="ButtonThemeEnum.SAVE"
          (onClick)="onSave()"
          [disabled]="saving() || !isFormValid()"
          tooltip="Enregistrer">
        </yo-button>
        <yo-button
          class="mg-l-5"
          [theme]="ButtonThemeEnum.CANCEL"
          (onClick)="close()"
          tooltip="Fermer"
          iconClass="fas fa-times">
        </yo-button>
      </div>
    </div>

  </div>

</dx-popup>
